import {
  collection,
  getDocs,
  addDoc,
  deleteDoc,
  doc,
  query,
  where,
  updateDoc,
  serverTimestamp,
} from 'firebase/firestore';
import { db } from './firebase';

const ALLOWED_USERS_COL = 'allowedUsers';
const AUTO_DOMAIN = '@mikkelparken.no';
const SUPER_ADMIN_EMAIL = import.meta.env.VITE_ADMIN_EMAIL || '';

export function isSuperAdmin(email) {
  return email?.toLowerCase() === SUPER_ADMIN_EMAIL.toLowerCase();
}

export function hasAutoDomain(email) {
  return email?.toLowerCase().endsWith(AUTO_DOMAIN);
}

export async function isUserAllowed(email) {
  if (!email) return false;
  const lower = email.toLowerCase();

  // Auto-allow @mikkelparken.no domain
  if (hasAutoDomain(lower)) return true;

  // Super-admin always allowed
  if (isSuperAdmin(lower)) return true;

  // Check whitelist
  const q = query(collection(db, ALLOWED_USERS_COL), where('email', '==', lower));
  const snap = await getDocs(q);
  return !snap.empty;
}

export async function isAdmin(email) {
  if (!email) return false;
  const lower = email.toLowerCase();

  if (isSuperAdmin(lower)) return true;

  const q = query(collection(db, ALLOWED_USERS_COL), where('email', '==', lower));
  const snap = await getDocs(q);
  if (snap.empty) return false;
  return snap.docs[0].data().isAdmin === true;
}

export async function getAllowedUsers() {
  const snap = await getDocs(collection(db, ALLOWED_USERS_COL));
  return snap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
}

export async function addAllowedUser(email, addedBy, makeAdmin = false) {
  const lower = email.toLowerCase().trim();

  // Check if already exists
  const q = query(collection(db, ALLOWED_USERS_COL), where('email', '==', lower));
  const snap = await getDocs(q);
  if (!snap.empty) {
    throw new Error('Denne epostadressa er allereie lagt til');
  }

  return addDoc(collection(db, ALLOWED_USERS_COL), {
    email: lower,
    isAdmin: makeAdmin,
    addedBy: addedBy,
    addedAt: serverTimestamp(),
  });
}

export async function removeAllowedUser(docId) {
  await deleteDoc(doc(db, ALLOWED_USERS_COL, docId));
}

export async function toggleAdminRole(docId, newIsAdmin) {
  await updateDoc(doc(db, ALLOWED_USERS_COL, docId), { isAdmin: newIsAdmin });
}
